import type { FC } from 'react'
import RewardsProgress from '../../shared/top-bar/receipient-section/RewardsProgress'
import { useShoppingCartTotals } from '../hooks/useShoppingCartTotals'
import RecipientEdit from '../../recipient/RecipientEdit'
import LgBreakpoint from '@g4g/ui/src/utility/LgBreakpoint'
import RewardList from '../../shared/rewards/RewardList'

const Totals: FC = () => {
  const { total } = useShoppingCartTotals()

  return (
    <div
      className="flex flex-col p-4 pb-6 rounded sm:space-x-12 bg-gray-600/20 sm:flex-row"
      data-cy="shop-cart-totals"
    >
      <div className="flex flex-col grow">
        <div className="flex justify-between w-full">
          <h2 className="text-lg font-bold text-white font-poppins">Total</h2>
          <LgBreakpoint max={<RecipientEdit />} />
        </div>
        <LgBreakpoint max={<RewardsProgress />} />
        <div className="flex justify-end px-1 mb-2 text-sm text-white/50">Loot</div>
        <div className="flex flex-wrap items-center justify-end w-full">
          {total && !!total.loot.length && <RewardList loot={total.loot} shine />}
        </div>
      </div>
    </div>
  )
}

export default Totals
